<template>
  <footer>
    <div class="con">
      <div class="left">
        <div class="smallTilte">COTACT ME</div>
        <h3>联系我们</h3>
        <p>
          电话：010-65202100<br/>邮箱：ad@kuxuan-inc.com <br/>地址：北京市朝阳区东四环中路41号嘉泰国际大厦
        </p>
      </div>
      <img src="https://kx-gw.oss-cn-beijing.aliyuncs.com/kxEvm.png" class="kxEvm"/>
    </div>
    <div class="recordBottom recordBottom1">
      Copyright © 2015-2021 酷炫网络 ｜ 北京酷炫网络技术股份有限公司 All rights reserved <a href="http://beian.miit.gov.cn/" target="_blank" style="color:rgba(135, 135, 135, 1);">京ICP备14056088号</a>
    </div>
    <div class="recordBottom recordBottom2">
      Copyright © 2015-2021 北京酷炫网络技术股份有限公司<br/> All rights reserved <a href="http://beian.miit.gov.cn/" target="_blank" style="color:rgba(135, 135, 135, 1);">京ICP备14056088号</a>
    </div>
    <!-- 回到顶部 -->
    <img class="goTop" v-if="scrollFlag" @click="goTopScrollEvent" src="https://kx-gw.oss-cn-beijing.aliyuncs.com/goTop_icon.png"/>
  </footer>
</template>

<script>
import $ from 'jquery'

export default {
  name: 'foot',
  data () {
    return {
      scrollFlag: false
    }
  },
  mounted(){
    this.scrollTop();
  },
  methods:{
    scrollTop () {
      var _this = this;
      $(window).scroll(function(){
        var sTop = $(this).scrollTop();
        if(sTop > 700){
          _this.scrollFlag = true;
        }else{
          _this.scrollFlag = false;
        }
      });
    },
    goTopScrollEvent () {
      //回到顶部
      $("html,body").animate({ scrollTop: 0 }, 200);
    }

  }
}
</script>

<style scoped lang="scss">
  footer{
    width: 100%;
    height: 4.2rem;
    background: #202020;
    .con{
      max-width: 11.4rem;
      height: 100%;
      position: relative;
      margin: auto;
      .left{
        position: absolute;
        left: 0;
        top: .54rem;
        .smallTilte{
          color: #fff;
          font-size: 0.18rem;
          line-height: 0.25rem;
          -webkit-text-stroke:0.01rem #979797;
          text-stroke:0.01rem #979797;
        }
        h3{
          color: #fff;
          font-size: 0.35rem;
          line-height: 0.49rem;
          margin-top: 0.18rem;
          &::after{
            content: '';
            display: block;
            width: 0.58rem;
            height: 0.04rem;
            background: #ff4400;
            box-shadow:0 0.01rem 0.04rem 0 rgba(255,110,12,0.42);
            border-radius:0.02rem;
            margin-top: 0.28rem;
          }
        }
        p{
          color: #ffffff;
          font-size: 0.2rem;
          line-height: 0.3rem;
          margin-top: 0.5rem;
        }
      }
      .kxEvm{
        width: 2.12rem;height: 2.12rem;position: absolute;
        top: 1rem;right: 0;
      }
    }
  }
  .goTop{
    position: fixed;
    bottom: 1rem;
    right: 0rem;
    width: 0.5rem;
  }
.recordBottom{
      background: #262626;
      clear: both;
      font-size: 12px;
      font-weight: 400;
      line-height: 40px;
      text-align: center;
      color: rgba(135, 135, 135, 1);
  }
  .recordBottom1{
    display: block;
  }
  .recordBottom2{
    display: none;
  }
  @media screen and (max-width: 640px) {
    .recordBottom2{
      display: block;
      line-height: 20px;
      padding: 4px 0;
    }
    .recordBottom1{
      display: none;
    }
    .goTop{
      position: fixed;
      bottom: 1rem;
      right: 0rem;
      width: 0.3rem;
    }
    footer{
    width: 100%;
    height: 3.5rem;
    background: #202020;
    .con{
      position: relative;
      margin: auto;
      .left{
        position: absolute;
        left: 0.2rem;
        top: 0.5rem;
        .smallTilte{
          color: #fff;
          font-size: 0.14rem;
          line-height: 0.25rem;
          -webkit-text-stroke:0.01rem #979797;
          text-stroke:0.01rem #979797;
        }
        h3{
          color: #fff;
          font-size: 0.18rem;
          line-height: 0.28rem;
          margin-top: 0.1rem;
          &::after{
            content: '';
            display: block;
            width: 0.4rem;
            height: 0.02rem;
            background: #ff4400;
            box-shadow:0 0.01rem 0.04rem 0 rgba(255,110,12,0.42);
            border-radius:0.02rem;
            margin-top: 0.1rem;
          }
        }
        p{
          color: #ffffff;
          font-size: 0.14rem;
          line-height: 0.24rem;
          margin-top: 0.2rem;
        }
      }
      .kxEvm{
        width: 1rem;height: 1rem;position: absolute;
        top: 0.6rem;right: 0.3rem;
      }
    }
  }
  }
</style>



// WEBPACK FOOTER //
// src/components/pc/public/Foot.vue